<ng-template #btnTemplate let-item>
  <button class="no-underline link-hover flex flex--row" (click)="emitClick(item.data)">
    {{ item.options.btnText }} <fcom-icon class="ps-xsmall-l" [name]="item.options.btnIcon"></fcom-icon>
  </button>
</ng-template>
<table class="table fill">
  <caption class="is-vishidden">
    {{
      caption
    }}
  </caption>
  <thead *ngIf="headers?.length > 0">
    <tr>
      <th
        class="align-left ps-medium-y ps-xsmall-x border-bottom nordic-blue-50-border"
        [ngClass]="header?.options?.class"
        *ngFor="let header of headers"
        #tableHeader
      >
        <ng-container *ngTemplateOutlet="headerTemplate; context: { $implicit: header }"></ng-container>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of tableData">
      <td
        *ngFor="let header of headers"
        class="border-bottom nordic-blue-50-border ps-small-y ps-xsmall-x"
        [ngClass]="row[header.key]?.options?.class"
      >
        <ng-container *ngIf="!row[header.key]?.options?.useBtn">
          <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: row[header.key].data }"></ng-container>
        </ng-container>

        <ng-container *ngIf="row[header.key]?.options?.useBtn">
          <ng-container
            *ngTemplateOutlet="
              btnTemplate;
              context: { $implicit: { data: row[header.key].data, options: row[header.key]?.options } }
            "
          ></ng-container>
        </ng-container>
      </td>
    </tr>
  </tbody>
</table>
<fcom-pagination
  *ngIf="usePagination"
  [totalItems]="totalPaginationItems"
  [textBeforePages]="textBeforePages"
  (indexesChange)="changeIndexes($event)"
  [itemsPerPageOptions]="itemsPerPageOptions"
></fcom-pagination>
